import tgIcon from '../i/i_tg.svg';
import emailIcon from '../i/i_email.svg';

function Footer() {
  return (
    <footer>
        <div className='copyright'>
            &copy; Кабанова М. А.,&nbsp;
            <span className='copyrightYear'>
                {
                    new Date().getFullYear()
                }
            </span>
        </div>
        <div className='contacts'>
            <a href='https://t.me/my_plants_app' target="_blank" rel="noopener noreferrer">
                <img src={tgIcon} className='contactsIcon' alt='telegram' />
            </a>
            <a href='mailto:mo.9in9er@gmail.com'>
                <img src={emailIcon} className='contactsIcon' alt='email' />
            </a>
        </div>
    </footer>
  );
}

export default Footer;